<template>
  <el-pagination
    small
    background
    layout="prev, pager, next"
    :total="props.total"
    :page-size="props.pageSize"
    :default-current-page="props.pageNum"
    @current-change="currentChange"
    @prev-click="prevPage"
    @next-click="nextPage"
  />
</template>

<script lang="ts" setup>
import {} from "vue";

const props = withDefaults(
  defineProps<{
    total: number;
    pageSize: number;
    pageNum: number;
  }>(),
  {}
);
// 更改dialog的显示与隐藏
let emit = defineEmits(["changePage"]);

// 改变页码
const currentChange = (currentPage: number) => {
  emit("changePage", currentPage);
};

const prevPage = (currentPage: number) => {
  emit("changePage", currentPage);
};

const nextPage = (currentPage: number) => {
  emit("changePage", currentPage);
};
</script>

<style lang="scss" scoped></style>

<style>
.el-pagination--small .btn-next,
.el-pagination--small .btn-prev,
.el-pagination--small .el-pager li {
  width: 38px !important;
  height: 32px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 32px !important;
  border-radius: 2px !important;
  border: 1px solid #23956a !important;
  background-color: #fff !important;
  color: #23956a !important;
  margin: 0 8px !important;
}

.el-pagination.is-background .btn-next.is-active,
.el-pagination.is-background .btn-prev.is-active,
.el-pagination.is-background .el-pager li.is-active {
  background: #229168 !important;
  color: #fff !important;
}
</style>
